import axiosApiInstance from '@services/custom-axios-instance';
import { DeviceMedicalTest, devicesResponseSearch, newDeviceProps } from '@modules/devices/types/types-devices';
import { generateUrl } from "@services/generateUrl/generateUrl";

/**
 * Retrieves devices from a host using its ID
 * @param hostId 
 * @returns 
 */
export const getDevices = async (hostId: string) => {
  try {
    return await axiosApiInstance.get<devicesResponseSearch>(`${generateUrl()}/drproxservices/devices/${hostId}`)
  } catch (e) {
    throw new Error('something was wrong');
  }
}

export const getServiceDevices = async (hostId: string, healthCareServiceId: number) => {
  try {
    return await axiosApiInstance.get(`${generateUrl()}/drproxservices/devices/${hostId}/healthcare-service/${healthCareServiceId}`)
  } catch (e) {
    throw new Error('something was wrong');
  }
}

export const getDevicesByOrganizationId = async (organizationId: number) => {
  try {
    return await axiosApiInstance.get(`${generateUrl()}/drproxservices/devices/organization/${organizationId}`)
  } catch (e) {
    throw new Error('something was wrong');
  }
}

export const addDevice = async (data: newDeviceProps) => {
  try {
    console.log(data);
   return await axiosApiInstance.post(`${generateUrl()}/drproxservices/device/${data.organizationHostId}`, data)
  } catch (e) {
    throw new Error('something was wrong');
  }
};

export const editDevice = async (data: newDeviceProps) => {
  try {
    // console.log(data);
    return await axiosApiInstance.put(`${generateUrl()}/drproxservices/device/${data.deviceId}`, data)
  } catch (e) {
    throw new Error('something was wrong');
  }
};

export const deleteDevices = async (id: number) => {
  console.log(id);
  try {
    console.log(id);
    return await axiosApiInstance.delete(`${generateUrl()}/drproxservices/device/${id}`)
  } catch (e) {
    throw new Error('something was wrong');
  }
};

export const getDeviceByMedicalTest = (medicalTestCode: string, organizationId: number) => {
  return axiosApiInstance
    .get(
      `${generateUrl()}/drproxservices/catalog/device-type/medical-test?medicalTestCode=${medicalTestCode}&organizationId=${organizationId}`
    )
    .then((response) => {
      const data = response.data
      return data as DeviceMedicalTest[]
    })
}